module.exports = __webpack_public_path__ + "static/Graphik-Regular-Web-528101d44392cd7262a62e56105e22f2.woff2";